import { computed, Injectable, signal } from "@angular/core";
import { PaginationInfo } from "../../Request/Dto/RequestSearchResponse";
import { TestimonyFollowupItem, TestimonyReportEntity } from "../Dto/TestimonyModel";
import { TestimonyStateModel } from "../Dto/TestimonyStateModel";
import { TestimonyFollowupRequest, TestimonySearchRequest } from "../Dto/TestimonySearchRequest";

const emptyPagination: PaginationInfo = { page: 1, limit: 10, total: 0, pages: 0 };
const initialState: TestimonyStateModel = {
  reports: [],
  followups: [],
  reportPagination: emptyPagination,
  followupPagination: emptyPagination,
  reportSearchParams: { page: 1, limit: 10 },
  followupSearchParams: { page: 1, limit: 10 },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class TestimonyState {
  private readonly state = signal<TestimonyStateModel>(initialState);

  readonly reports = computed(() => this.state().reports);
  readonly followups = computed(() => this.state().followups);
  readonly reportPagination = computed(() => this.state().reportPagination);
  readonly followupPagination = computed(() => this.state().followupPagination);
  readonly reportSearchParams = computed(() => this.state().reportSearchParams);
  readonly followupSearchParams = computed(() => this.state().followupSearchParams);
  readonly loading = computed(() => this.state().loading);
  readonly error = computed(() => this.state().error);

  setReports(reports: TestimonyReportEntity[], pagination: PaginationInfo, params: TestimonySearchRequest): void {
    this.state.update((state) => ({ ...state, reports, reportPagination: pagination, reportSearchParams: params, error: null }));
  }

  setFollowups(followups: TestimonyFollowupItem[], pagination: PaginationInfo, params: TestimonyFollowupRequest): void {
    this.state.update((state) => ({
      ...state,
      followups,
      followupPagination: pagination,
      followupSearchParams: params,
      error: null,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }
}
